export enum AuthType {
    SAML = 'SAML',
    JWT = 'JWT'
}

export interface CatalogAuthConfig {
    appId: string;
    path: string;
    category?: string;
    authType?: AuthType;
    queryParams?: Record<string, string>;
}

// All these links need to come from AEM
export const CATALOG_AUTH_CONFIG: CatalogAuthConfig[] = [
    {
        appId: "Service Library 2.0",
        authType: AuthType.SAML,
        category: "internal",
        path: "/login-saml-proxy?mode=initSSO&spName=ServiceLibrarySrpSP",
        queryParams: {
            mode: "initSSO",
            spName: "ServiceLibrarySrpSP"
        }
    },
    {
        appId: "TireBox Catalog",
        authType: AuthType.SAML,
        category: "internal",
        path: "/login-saml-proxy?mode=initSSO&spName=KeycloakSP",
        queryParams: {
            mode: "initSSO",
            spName: "KeycloakSP"
        }
    },
    {
        appId: "POI Link",
        authType: AuthType.SAML,
        category: "external",
        path: "/login-saml-proxy?mode=initSSO&spName=POISP",
        queryParams: {
            mode: "initSSO",
            spName: "POISP"
        }
    },
    {
        appId: "TI Link",
        authType: AuthType.SAML,
        category: "external",
        path: "/login-saml-proxy?mode=initSSO&spName=TISP",
        queryParams: {
            mode: "initSSO",
            spName: "TISP"
        }
    },
    {
        appId: "Service Box Multi-Brand",
        authType: AuthType.JWT,
        path: "/sbmb/sbmb",
        category: "internal",
    },
    {
        appId: "Multi-Brand Tire Catalogs",
        authType: AuthType.JWT,
        path: "/tirecatalog/tirecatalog",
        category: "internal"
    },
    {
        appId: "Saved Shopping Cart",
        path: "/savedshoppingcart",
        category: "internal"
    },
    {
        appId: "Banner",
        path: "/banner",
        category: "internal"
    },
    {
        appId: "Notification List",
        path: "/notifications",
        category: "internal"
    },
    {
        appId: "Subscriptions",
        path: "/subscriptions",
        category: "internal"
    },
    {
        appId: "Estimate list",
        path: "/estimate-list",
        category: "internal"
    },
    {
        appId: "My Settings",
        path: "/settings",
        category: "internal"
    },
    {
        appId: "My Account",
        path: "/my-account",
        category: "internal"
    },
    {
        appId: "Order List",
        path: "/my-orders",
        category: "internal"
    },
    {
        appId: "My Return Orders",
        path: "/my-return",
        category: "internal"
    },
    {
        appId: 'Create New Order From Import',
        path: "/import-to-create-order",
        category: "internal"
    }
]